import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { cn } from 'utils/ui/classes';
function getColor(status) {
    switch (status) {
        case 'approved':
            return 'bg-green-100 text-green-800 hover:bg-green-100';
        case 'accepted':
            return 'bg-blue-100 text-blue-800 hover:bg-blue-100';
        case 'pending':
            return 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100';
        case 'pending-admin':
            return 'bg-orange-100 text-orange-800 hover:bg-orange-100';
        case 'pending-shipper':
            return 'bg-amber-100 text-amber-800 hover:bg-amber-100';
        case 'declined':
            return 'bg-red-100 text-red-800 hover:bg-red-100';
        default:
            return 'bg-gray-100 text-gray-800 hover:bg-gray-100';
    }
}
function getLabel(status) {
    switch (status) {
        case 'approved':
            return 'Approved';
        case 'accepted':
            return 'Accepted';
        case 'pending':
            return 'Pending';
        case 'pending-admin':
            return 'Pending Admin';
        case 'pending-shipper':
            return 'Pending Shipper';
        case 'declined':
            return 'Declined';
        default:
            return status || '—';
    }
}
export default function AccessorialRequestStatusBadge({ className = '', status, }) {
    if (!status)
        return null;
    return (React.createElement(Badge, { className: cn('text-xs whitespace-nowrap self-start shrink-0 grow-0', getColor(status), className) }, getLabel(status)));
}
